import React, { useState } from "react";
import { ImagePreviewModal } from "./ImagePreviewModal";
import { FileShareButton } from "./FileShareButton";
import { getFileNameFromUrl } from "../Utils/Common";
import { Ripple } from "primereact/ripple";

interface ImagePreviewProps {
    src: string;
    alt?: string;
    className?: string;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ src, alt, className }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <div
                className={`fxpv-button p-ripple ${className ?? ''}`}
                onClick={() => setOpen(true)}
            >
                <i className="bi bi-card-image"></i>
                <Ripple />
            </div>

            <ImagePreviewModal
                open={open}
                src={src}
                alt={alt}
                onClose={() => setOpen(false)}
                title="Preview"
                toolbarRightSlot={
                    <FileShareButton
                        fileUrl={src}
                        fileName={getFileNameFromUrl(src)}
                        maxBytes={25 * 1024 * 1024}
                        onFallbackUsed={(t) => console.log("Fallback used:", t)}
                        onError={(e) => console.error(e)}
                        variant="icon"
                    />
                }
            />
        </>
    );
}

export default ImagePreview;
